<template>
  <div id="container" class="page_main information">
    <div class="skip_direct">
      <a href="#gnb"><span>서비스 메뉴 바로가기</span></a>
      <a href="#main"><span>본문 바로가기</span></a>
    </div>

    <!-- Header -->
    <header id="header">
      <div class="pc_header">
        <h1 class="main_tit">
          <a href="#" class="main_link">
            <span class="wrap_logo">
              <img :src="logoImage" alt="coggiri" class="logo_img" />
            </span>
          </a>
        </h1>
        <nav id="gnb" class="gnb">
          <ul class="gnb_list">
            <li><a href="https://shoplus.gitbook.io/cert-product/" class="gnb_link">정품 인증 서비스</a></li>
            <li><a href="https://shoplus.gitbook.io/cert-product/policy/price" target="_blank" class="gnb_link">가격 정책</a></li>
            <li><a href="https://shoplus.gitbook.io/cert-product/" target="_blank" class="gnb_link">고객지원</a></li>
          </ul>
        </nav>
        <div class="util">
          <a href="javascript:void(0)" class="login_link" @click="handleLoginLogout">{{ loginButtonText }}</a>
          <a href="javascript:void(0)" class="btn" @click="handleStartService">시작하기</a>
        </div>
      </div>

      <!-- Mobile Header -->
      <div class="m_header">
        <button type="button" class="ham_btn" @click="toggleMobileMenu">
          <strong class="blind">메뉴열기</strong>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <h1 class="main_tit">
          <a href="#" class="main_link">
            <span class="wrap_logo">
              <img :src="logoImage" alt="coggiri" class="logo_img" />
            </span>
          </a>
        </h1>
        <a href="javascript:void(0)" class="btn" @click="handleLoginLogout">{{ loginButtonText }}</a>
        <div class="m_menu" :class="{ open: isMobileMenuOpen }">
          <div class="dimmed" @click="closeMobileMenu"></div>
          <div class="wrap_menu" :class="{ open: isMobileMenuOpen }">
            <div class="main_tit">
              <a href="#" class="main_link">
                <span class="wrap_logo">
                  <img :src="logoImage" alt="coggiri" class="logo_img" />
                </span>
              </a>
            </div>
            <nav id="mGnb" class="mGnb">
              <ul class="mgnb_list">
                <li><a href="https://shoplus.gitbook.io/cert-product/" class="gnb_link">정품 인증 서비스</a></li>
                <li><a href="https://shoplus.gitbook.io/cert-product/policy/price" target="_blank" class="gnb_link">가격 정책</a></li>
                <li><a href="https://shoplus.gitbook.io/cert-product/" target="_blank" class="gnb_link">고객지원</a></li>
              </ul>
            </nav>
            <a href="javascript:void(0)" class="btn" @click="handleLoginLogout">{{ loginButtonText }}</a>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main id="main">
      <div class="contents">
        <!-- Intro Section -->
        <div class="intro_section">
          <h2 class="intro_tit">쇼핑몰 브랜드 관리 필수.<br />정품 인증 서비스</h2>
          <p class="intro_desc">자발적인 쇼핑몰 회원 가입과 관리까지<br />제품의 신뢰는 매출로 연결됩니다.</p>
          <div class="wrap_btn">
            <a href="javascript:void(0)" class="btn" @click="handleStartService">바로 시작하기</a>
            <button @click="smoothScrollToTarget" class="btn btn2">자세히 보기</button>
          </div>
        </div>

        <!-- Service Info Section -->
        <div class="cont_section">
          <div class="sec_inner">
            <div id="target">
              <h3 class="section_tit">정품 인증 서비스<br />사용해 보세요</h3>
            </div>
            <ul class="info_list">
              <li>
                <a href="javascript:void(0)" class="info_link">
                  <div class="wrap_img">
                    <video :src="getAssetPath('images/customer.mp4')" class="thumb_img" autoplay muted loop></video>
                  </div>
                  <strong class="info_tit">쇼핑몰 회원 가입 증가</strong>
                  <p class="info_desc">여러 채널에서 구매한 고객들<br />쇼핑몰 유입과 자발적인 회원 가입을 해요.</p>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" class="info_link">
                  <div class="wrap_img">
                    <video :src="getAssetPath('images/qrcode.mp4')" class="thumb_img" autoplay muted loop></video>
                  </div>
                  <strong class="info_tit">QR 코드를 통한 인증</strong>
                  <p class="info_desc">고객은 제품에 있는 QR코드를 통해<br />쇼핑몰로 바로 이동하여 인증 완료!</p>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" class="info_link">
                  <div class="wrap_img">
                    <video :src="getAssetPath('images/alarm.mp4')" class="thumb_img" autoplay muted loop></video>
                  </div>
                  <strong class="info_tit">카톡/SMS/메일 디지털 인증</strong>
                  <p class="info_desc">구매확정시 발송되는 알림 메시지<br />고객은 구매 후 인증까지 완료되어요.</p>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" class="info_link">
                  <div class="wrap_img">
                    <video :src="getAssetPath('images/code.mp4')" class="thumb_img" autoplay muted loop></video>
                  </div>
                  <strong class="info_tit">편리한 시리얼코드 등록</strong>
                  <p class="info_desc">시리얼코드를 새롭게 만들수도 있고<br />기존 사용하는 시리얼코드 모두 가능해요.</p>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" class="info_link">
                  <div class="wrap_img">
                    <video :src="getAssetPath('images/vip.mp4')" class="thumb_img" autoplay muted loop></video>
                  </div>
                  <strong class="info_tit">인증 고객 특별 관리</strong>
                  <p class="info_desc">정품 인증/등록한 고객을 확인하고<br />충성 고객으로 관리해 보세요.</p>
                </a>
              </li>
              <li>
                <a href="javascript:void(0)" class="info_link">
                  <div class="wrap_img">
                    <video :src="getAssetPath('images/manage.mp4')" class="thumb_img" autoplay muted loop></video>
                  </div>
                  <strong class="info_tit">정품 인증 이력 관리</strong>
                  <p class="info_desc">시리얼코드 생성부터 등록 이후까지<br />이력을 확인하고 AS 및 고객 관리를 해보세요.</p>
                </a>
              </li>
            </ul>
            <div class="wrap_btn">
              <a href="javascript:void(0)" class="btn" @click="handleStartService">무료로 시작하기</a>
            </div>
          </div>
        </div>

        <!-- Feature Sections -->
        <div class="cont_section">
          <div class="row_cont type_left">
            <span class="zone_img">
              <video :src="getAssetPath('images/960bn1.mp4')" class="thumb_img" autoplay muted loop></video>
            </span>
            <div class="zone_cont">
              <h3 class="cont_tit">우리 회사 정품 시스템 구축</h3>
              <p class="cont_desc">업종에 상관없이 정품 인증 시스템을 만들 수 있어요.<br />효과적인 브랜드의 시작. 신뢰를 제공하세요.</p>
              <a href="javascript:void(0)" class="btn" @click="handleStartService">서비스 시작하기</a>
            </div>
          </div>
          <div class="row_cont">
            <span class="zone_img">
              <video :src="getAssetPath('images/960bn2.mp4')" class="thumb_img" autoplay muted loop></video>
            </span>
            <div class="zone_cont">
              <h3 class="cont_tit">구축 비용은 없이. 합리적인 사용료</h3>
              <p class="cont_desc">
                비용은 줄이고 매출을 늘리시도록<br />월 사용료를 통해 시스템을 사용하실 수 있어요.<br />샵플러스는 비즈니스 성공을
                함께합니다.
              </p>
              <a href="javascript:void(0)" class="btn" @click="handleStartService">서비스 시작하기</a>
            </div>
          </div>
          <div class="row_cont type_left">
            <span class="zone_img">
              <video :src="getAssetPath('images/960bn3.mp4')" class="thumb_img" autoplay muted loop></video>
            </span>
            <div class="zone_cont">
              <h3 class="cont_tit">제품에 대한 신뢰감</h3>
              <p class="cont_desc">고객들은 정품과 보증기간/AS를 인지할 수 있어<br />안심하고 제품을 구매할 수 있어요.</p>
              <a href="javascript:void(0)" class="btn" @click="handleStartService">서비스 시작하기</a>
            </div>
          </div>
          <div class="row_cont">
            <span class="zone_img">
              <video :src="getAssetPath('images/960bn4.mp4')" class="thumb_img" autoplay muted loop></video>
            </span>
            <div class="zone_cont">
              <h3 class="cont_tit">세상에 단 하나. 정품인증코드</h3>
              <p class="cont_desc">데이터를 안전하게 암호화하며<br />접근 제어 및 저장까지 안전하게 사용할 수 있어요.</p>
              <a href="javascript:void(0)" class="btn" @click="handleStartService">서비스 시작하기</a>
            </div>
          </div>
        </div>

        <!-- Final CTA Section -->
        <div class="intro_section">
          <h2 class="section_tit">브랜딩 관리에 꼭 필요한 서비스</h2>
          <p class="intro_desc">정품 인증을 통한 브랜드 관리<br />제품의 신뢰는 매출로 연결됩니다.</p>
          <div class="wrap_btn">
            <a href="javascript:void(0)" class="btn" @click="handleStartService">무료로 시작하기</a>
          </div>
        </div>
      </div>
    </main>

    <!-- Footer -->
    <footer id="footer">
      <div class="wrap_sitemap">
        <div class="zone_logo">
          <img :src="getAssetPath('images/icon_1.svg')" width="48" height="48" alt="" class="ci_img" />
          <span class="logo_txt">쇼핑몰 브랜드 관리<br />최적의 CRM 시스템<br />정품 인증 서비스.</span>
        </div>
        <div class="zone_sitemap">
          <ul class="sitemap_list">
            <li>
              <a href="javascript:void(0)" class="map_link">솔루션 소개</a>
              <ul class="lnb_list">
                <li><a href="https://shoplus.gitbook.io/cert-product/" class="lnb_link">정품 인증 서비스</a></li>
                <li><a href="https://shoplus.gitbook.io/cert-product/reference" target="_blank" class="lnb_link">활용사례</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" class="map_link">고객지원</a>
              <ul class="lnb_list">
                <li><a href="https://shoplus.gitbook.io/cert-product/faq" target="_blank" class="lnb_link">자주 묻는 질문</a></li>
                <li><a href="https://shoplus.gitbook.io/cert-product" target="_blank" class="lnb_link">이용가이드</a></li>
                <li><a href="mailto:contact@coggiri.com" class="lnb_link">문의하기</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" class="map_link">정책안내</a>
              <ul class="lnb_list">
                <li><a href="https://shoplus.gitbook.io/cert-product" target="_blank" class="lnb_link">가격정책</a></li>
                <li><a href="https://shoplus.gitbook.io/cert-product/policy/use" target="_blank" class="lnb_link">이용약관</a></li>
                <li>
                  <a href="https://shoplus.gitbook.io/cert-product/policy/privacy" target="_blank" class="lnb_link">개인정보처리방침</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" class="map_link">회사정보</a>
              <ul class="lnb_list">
                <li><a href="https://www.shoplus.biz" target="_blank" class="lnb_link">회사소개</a></li>
                <li><a href="javascript:void(0)" class="lnb_link">채용</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="wrap_info">
        <div class="zone_info">
          <strong class="company_name">코끼리컴퍼니(주)</strong>
          <p class="info_company">
            대표 : 이병화<span class="bar">ㅣ</span>사업자 등록번호 : 885-81-02112<span class="bar">ㅣ</span>통신판매업신고 :
            제2025-서울서초-2512호<span class="bar">ㅣ</span
            ><a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8858102112" target="_blank">사업자번호조회</a><br />
            고객지원 : 050-5277-7770<span class="bar">ㅣ</span>메일 : contact@coggiri.com<span class="bar">ㅣ</span>주소 : 서울특별시 서초구
            방배로25길 20, 2F (우편번호 06572)<br />
            Copyright © CoggiriCompny Corp. ALL RIGHT RESERVED.
          </p>
        </div>
        <div class="select_box">
          <button type="button" class="select_btn" aria-haspopup="true" @click="toggleLanguageSelect">
            한국어<span class="icon"></span>
          </button>
          <div class="slt_layer" :class="{ active: isLanguageSelectOpen }">
            <ul class="slt_list">
              <li>
                <a href="javascript:void(0)" class="slt_link on">한국어<span class="icon">선택됨</span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Information",
  data() {
    return {
      isMobileMenuOpen: false,
      isLanguageSelectOpen: false,
      logoImage: "https://cert-product.dev.shoplus.store/img/shoplus_logo.06bb1b79.jpg",
      isUserLoggedIn: false, // 로그인 상태
    };
  },
  computed: {
    // 로그인 버튼 텍스트를 동적으로 계산
    loginButtonText() {
      return this.isUserLoggedIn ? "로그아웃" : "로그인";
    },
  },
  methods: {
    getAssetPath(path) {
      return require("@/assets/authservice/" + path);
    },
    // 로그인/로그아웃 통합 처리 함수
    handleLoginLogout(event) {
      event.preventDefault();
      if (this.isUserLoggedIn) {
        this.logout();
      } else {
        this.goToLogin();
      }
    },
    // 로그인 페이지로 이동하는 함수
    goToLogin() {
      console.log("goToLogin called - attempting to navigate to login page");

      // 방법 1: 라우터 이름으로 이동 시도
      this.$router
        .push({ name: "CommonLogin" })
        .catch((err) => {
          console.error("Router push by name failed:", err);

          // 방법 2: 경로로 이동 시도
          return this.$router.push("/authservice/login");
        })
        .catch((err) => {
          console.error("Router push by path failed:", err);
          console.log("Fallback to location.href");

          // 방법 3: 모든 Vue Router 방식이 실패하면 location.href로 대체
          window.location.href = "/authservice/login";
        });
    },
    // 로그아웃 함수
    logout() {
      console.log("Logout called - clearing user session");

      // 로컬/세션 스토리지에서 토큰 제거
      localStorage.removeItem("imweb_cert_access_token");
      sessionStorage.removeItem("current_mall_id");

      // Vuex store 초기화 (필요한 경우)
      if (this.$store) {
        this.$store.commit("SET_ACCESS_TOKEN", null);
        this.$store.commit("SET_MALL_ID", null);
      }

      // 로그인 상태 업데이트
      this.isUserLoggedIn = false;

      // 로그아웃 완료 메시지 (선택적)
      alert("로그아웃되었습니다.");

      // 필요한 경우 페이지 새로고침
      // window.location.reload();
    },
    // 로그인 여부를 체크하는 함수
    async checkLoginStatus() {
      // 여러 토큰 소스 확인
      const accessToken = localStorage.getItem("imweb_cert_access_token") || sessionStorage.getItem("access_token");
      if (accessToken) {
        await this.$store.dispatch("SET_ACCESS_TOKEN", {
          access_token: accessToken,
        });
        // api 로 login_check 호출해서도 확인 가능
        const loginInfo = await this.callLoginCheckAPI();
        if (loginInfo && loginInfo.mall_id) {
          this.isUserLoggedIn = true;
        }
      } else {
        this.isUserLoggedIn = false;
      }
      return this.isUserLoggedIn;
    },
    // login_check API 호출 함수
    async callLoginCheckAPI() {
      try {
        const M = await import("@/libs/mapping.js");
        const response = await M.default.api(M.default.entry("/get/member/login_check"));

        if (response && response.mall_id) {
          console.log("Login check API response:", response);
          return {
            mall_id: response.mall_id,
            mall_type: response.mall_type || "imweb", // 기본값으로 imweb 설정
          };
        }

        return null;
      } catch (error) {
        console.error("Login check API failed:", error);
        return null;
      }
    },
    // 시작하기 버튼 공통 처리 함수
    async handleStartService(event) {
      event.preventDefault();

      if (this.isUserLoggedIn) {
        // 로그인된 경우 login_check API 호출하여 mall_id 가져오기
        const loginInfo = await this.callLoginCheckAPI();

        if (loginInfo && loginInfo.mall_id) {
          // API로부터 받은 mall_id와 mall_type으로 serviceIntro 페이지로 이동
          const targetPath = `/authservice/${loginInfo.mall_id}/serviceIntro?mType=${loginInfo.mall_type}`;

          window.location.href = targetPath;
        } else {
          // API 호출 실패 시 기본 경로로 이동
          console.warn("Login check API failed, falling back to init page");
          this.$router.push("/authservice/init");
        }
      } else {
        // 로그인되지 않은 경우 로그인 페이지로 이동
        this.goToLogin();
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    toggleLanguageSelect() {
      this.isLanguageSelectOpen = !this.isLanguageSelectOpen;
    },
    smoothScrollToTarget() {
      const target = document.getElementById("target");
      const yOffset = -120;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
      this.smoothScrollTo(targetPosition, 2000);
    },
    smoothScrollTo(to, duration = 500) {
      const start = window.pageYOffset;
      const distance = to - start;
      const startTime = performance.now();

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function animate(time) {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = easeInOutCubic(progress);

        window.scrollTo(0, start + distance * ease);

        if (elapsed < duration) {
          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);
    },
  },
  mounted() {
    // 페이지 로드 시 로그인 상태 확인
    this.checkLoginStatus();

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".select_box") && this.isLanguageSelectOpen) {
        this.isLanguageSelectOpen = false;
      }
      if (!e.target.closest(".m_header") && this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", () => {});
  },
};
</script>

<style>
@import "../../assets/authservice/css/main.css";
</style>

<style scoped>
* {
  font-family: "Pretendard", "돋움", sans-serif;
}
#app,
#main,
#footer {
  text-align: left;
}
.v-application p {
  margin-bottom: 0;
}
h3 {
  margin-top: 0;
  margin-bottom: 0;
}
.v-application ul,
.v-application ol {
  padding-left: 0;
}
.mgnb_list a {
  color: #000;
}
.info_list .info_tit {
  color: #000;
  font-weight: 400;
}
.intro_section .wrap_btn {
  display: flex;
  justify-content: center;
  margin-top: 51px;
}

.wrap_btn .btn {
  display: inline-block;
  width: unset;
  height: 64px;
  padding: 0 30px;
  line-height: 64px;
  font-weight: 400;
}

.wrap_btn .btn + .btn {
  margin-top: 0px;
}

.btn {
  color: #fff;
}
.btn2 {
  color: #000;
}
#footer .sitemap_list .map_link {
  color: unset;
}
#footer .sitemap_list .lnb_list {
  padding-left: 0px;
}

.m_menu.active {
  display: block !important;
}

/* 모바일 메뉴 애니메이션 개선 */
.m_header .m_menu {
  display: block !important;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.m_header .m_menu.open {
  opacity: 1;
  visibility: visible;
}

.slt_layer.active {
  display: block !important;
}
@media screen and (max-width: 767px) {
  .m_header .main_tit .logo_img {
    height: unset;
  }
  .intro_section .wrap_btn .btn {
    display: block;
    margin: 0 auto;
  }
  .page_main .btn {
    height: 40px;
    max-width: 240px;
    font-size: 14px;
    line-height: 40px;
  }
  .intro_section .wrap_btn .btn + .btn {
    margin-top: 7px;
  }
}
</style>
